import React, { FC, HTMLAttributes } from 'react'

import classes from './card.module.scss'

type CardProps = HTMLAttributes<HTMLDivElement>

export const Card: FC<CardProps> = ({ children, className, ...props }) => (
  <div
    className={[classes.card, className].filter(Boolean).join(' ')}
    {...props}
  >
    {children}
  </div>
)

export default Card
